@if (question.type === 'TEXT' || question.type === 'SMALL_TEXT' || question.type === 'NUMBER' || question.type === 'POSTCODE') {
  <p [class.first]="first"
    [attr.aria-label]="'Answer to ' + messages.getText('WILL.text.' + question.id) + ' for group ' + group.index">
    {{ value }}
  </p>

} @else if (question.type === 'LARGE_TEXT') {
  <p [class.first]="first"
     [attr.aria-label]="'Answer to ' + messages.getText('WILL.text.' + question.id) + ' for group ' + group.index"
     [innerHTML]="breakLines(value)">
  </p>

} @else if (question.type === 'CURRENCY') {
  <p [class.first]="first"
     [attr.aria-label]="'Answer to ' + messages.getText('WILL.text.' + question.id) + ' for group ' + group.index">£{{ value }}</p>

} @else if (question.type === 'PERCENTAGE') {
  <p [class.first]="first"
     [attr.aria-label]="'Answer to ' + messages.getText('WILL.text.' + question.id) + ' for group ' + group.index">{{ value }}%</p>

} @else if (question.type === 'DROPDOWN' || question.type === 'RADIO' || question.type === 'CHECKBOX') {
  <p [class.first]="first"
     [attr.aria-label]="'Answer to ' + messages.getText('WILL.text.' + question.id) + ' for group ' + group.index">{{ optionValue }}</p>
}
